module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Toko")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/toko_target"
    }
  }, [_vm._v("Target")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding-left": "20px",
      "padding-top": "10px"
    }
  }, [_c('h4', [_c('b', [_vm._v("TARGET")])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding-right": "20px",
      "padding-top": "10px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Pilih Toko"
    },
    on: {
      "change": _vm.handleSelect1
    },
    model: {
      value: (_vm.toko1),
      callback: function($$v) {
        _vm.toko1 = $$v
      },
      expression: "toko1"
    }
  }, _vm._l((_vm.region), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item
      }
    })
  }), 1), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "month",
      "align": "right",
      "format": "yyyy-MM",
      "value-format": "yyyy-MM"
    },
    model: {
      value: (_vm.bulan),
      callback: function($$v) {
        _vm.bulan = $$v
      },
      expression: "bulan"
    }
  }), _vm._v("\n                       \n                      "), _c('el-button', {
    attrs: {
      "icon": "el-icon-search",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.getData()
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-plus",
      "type": "success",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.addData()
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('ve-histogram', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.barData,
      "settings": _vm.barSettings,
      "resize-delay": 100
    }
  })], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdd),
      expression: "loadingModalAdd"
    }],
    attrs: {
      "title": "Tambah Data",
      "visible": _vm.dialogFormVisible,
      "width": "800px",
      "top": "2%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formAdd",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Toko",
      "prop": "kode_toko"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.nama_toko),
      callback: function($$v) {
        _vm.nama_toko = $$v
      },
      expression: "nama_toko"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tanggal",
      "prop": "tanggal"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Pilih Tanggal"
    },
    on: {
      "change": _vm.handleChangeDate
    },
    model: {
      value: (_vm.tanggal),
      callback: function($$v) {
        _vm.tanggal = $$v
      },
      expression: "tanggal"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Budget",
      "prop": "budget"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.budget),
      callback: function($$v) {
        _vm.$set(_vm.row1, "budget", $$v)
      },
      expression: "row1.budget"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1(0, _vm.row1, 'formAdd')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalEdit),
      expression: "loadingModalEdit"
    }],
    attrs: {
      "title": "Edit Data",
      "visible": _vm.dialogFormEdit,
      "width": "35%",
      "top": "3%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "formEdit",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row1,
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Toko",
      "prop": "kode_toko"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "Cari Toko"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.region1),
      callback: function($$v) {
        _vm.region1 = $$v
      },
      expression: "region1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bulan",
      "prop": "bulan"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "month",
      "placeholder": "Pilih Bulan"
    },
    on: {
      "change": _vm.handleChangeDate
    },
    model: {
      value: (_vm.bulan),
      callback: function($$v) {
        _vm.bulan = $$v
      },
      expression: "bulan"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sales",
      "prop": "sales"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.sales),
      callback: function($$v) {
        _vm.$set(_vm.row1, "sales", $$v)
      },
      expression: "row1.sales"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Cost",
      "prop": "cost"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.cost),
      callback: function($$v) {
        _vm.$set(_vm.row1, "cost", $$v)
      },
      expression: "row1.cost"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "COGS",
      "prop": "cogs"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.cogs),
      callback: function($$v) {
        _vm.$set(_vm.row1, "cogs", $$v)
      },
      expression: "row1.cogs"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Profit",
      "prop": "profit"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.row1.profit),
      callback: function($$v) {
        _vm.$set(_vm.row1, "profit", $$v)
      },
      expression: "row1.profit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Waste",
      "prop": "waste"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmEdit1(0, _vm.row1, 'formEdit')
      }
    },
    model: {
      value: (_vm.row1.waste),
      callback: function($$v) {
        _vm.$set(_vm.row1, "waste", $$v)
      },
      expression: "row1.waste"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormEdit = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1(0, _vm.row1, 'formEdit')
      }
    }
  }, [_vm._v("Simpan")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDel),
      expression: "loadingModalDel"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormWilDel,
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormWilDel = $event
      }
    }
  }, [_c('h4', [_vm._v("Apakah Anda yakin akan menghapus data tersebut?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormWilDel = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDel1()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Informasi",
      "visible": _vm.dialogFormInfo,
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormInfo = $event
      }
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormInfo = false
      }
    }
  }, [_vm._v("OK")])], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61a73b38!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/master_data/TokoTarget1.vue
// module id = 1396
// module chunks = 2